import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: null,
  catalog: [],
  fetchingCatalog: false,
  commodities: [],
  tests: [],
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    fetchCompanyCatalog(state, action) {
      state.fetchingCatalog = true;
    },
    fetchCompanyCatalogSuccess(state, action) {
      state.catalog = action.payload.data.document;
      state.fetchingCatalog = false;
    },
    fetchCompanyCatalogFailure(state, action) {
      state.fetchingCatalog = false;
    },
    fetchCommodities(state, action) {
      state.loading = true;
    },
    fetchCommoditiesSuccess(state, action) {
      state.loading = false;
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {
      state.loading = false;
    },
    fetchTests(state, action) {
      state.loading = true;
    },
    fetchTestsSuccess(state, action) {
      state.loading = false;
      state.tests = action.payload.data.document;
    },
    fetchTestsFailure(state, action) {
      state.loading = false;
    },
    initializeState(state, action) {
      state.error = null;
      state.catalog = [];
      state.fetchingCatalog = false;
      state.commodities = [];
      state.tests = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = bookingSlice;
